import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { CookieService } from 'ngx-cookie';
import { catchError, Observable, throwError } from 'rxjs';

import { ToastService } from 'shared-modules-angular/toast';

import { ConfigService } from '../services/config';

@Injectable()
export class ApiUrlHttpInterceptor implements HttpInterceptor {
  private static readonly _AUTH_KEY: string = 'id_token';
  private readonly _timezoneOffset: number;

  constructor(
    private readonly _config: ConfigService,
    private readonly _toastService: ToastService,
    private readonly _cookieService: CookieService,
  ) {
    this._timezoneOffset = DateTime.local().offset;
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startUrl: string = request.url.substring(1, request.url.indexOf('/', 1));
    // const endUrl: string = request.url.substring(startUrl.length + 1);

    let url = '';

    switch (startUrl) {
      case 'assets':
        url = `.${request.url}`;
        break;
      // TODO add this once the translation is ready
      // case 'api':
      //   url = `${this._config.apiUrl}/${removeStartSlash(endUrl)}`;
      //
      //   url += (url.indexOf('?') === -1) ? '?_t=' : '&_t=';
      //   url += DateTime.local().toMillis();
      //
      //   url += `&tz=${this.timezoneOffset}&lang=en`;
      //   break;
      default:
        url = request.url;
    }

    const bearer: string | undefined = this._cookieService.get(ApiUrlHttpInterceptor._AUTH_KEY);
    const requestClone: HttpRequest<any> = request.clone({
      url,
      withCredentials: true,
      setHeaders: {
        Authorization: `Bearer ${bearer}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
      },
    });

    return next.handle(requestClone).pipe(
      catchError((error) => {
        // Don't show the error to the user if it's a HttpErrorResponse as the service who made the http request will handle it
        if (!(error instanceof HttpErrorResponse)) {
          this._toastService.error({ description: 'Something went wrong.' });
        }

        return throwError(() => error);
      }),
    );
  }
}
